import { Link, Route, Routes } from 'react-router-dom';
import Planetarium from './pages/Planetarium';
import AboutData from './pages/AboutData';
import PlanetNine from './pages/PlanetNine';

export default function App() {
  return (
    <div className="app">
      <header className="topbar">
        <Link to="/" className="brand">
          Planet 9 <span className="brand-suffix">— Solar System Explorer</span>
        </Link>
        <nav className="nav">
          <Link to="/">Planétarium</Link>
          <Link to="/planet-nine">Planet Nine</Link>
          <Link to="/about-data">Sources</Link>
        </nav>
      </header>

      <main className="main">
        <Routes>
          <Route path="/" element={<Planetarium />} />
          <Route path="/planet-nine" element={<PlanetNine />} />
          <Route path="/about-data" element={<AboutData />} />
        </Routes>
      </main>

      <footer className="site-footer">
        <span className="footer-main">
          Planet 9 — Educational interactive visualization · © {new Date().getFullYear()}{' '}
          Created by{' '}
          <a
            href="https://artofdev.space"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-brand"
          >
            Art of Dev
          </a>
        </span>
        <span className="footer-disclaimer">
          Planet Nine is a hypothesis — see{' '}
          <a href="/planet-nine">/planet-nine</a> &amp;{' '}
          <a href="/about-data">/about-data</a>
        </span>
      </footer>
    </div>
  );
}
